import ColumnType from '@/commons/wildcards/constants/ColumnType';
import { MSEnum } from '@/commons/enumeration';
// import listConstant from '@/commons/listConstant';
// import i18nGlobal from '@/i18ns/i18n';
// import commonFn from '@/commons/commonFunction';
// const i18n = i18nGlobal.global;

class ListConfigDefault {
  columnSettingDefault = {
    listNeedToApprove: [
      {
        caption: 'Tên công việc',
        dataField: 'TaskName',
        width: 426,
        isTree: true,
        type: 'custom',
        isShowExpandIcon: true,
        visible: true,
        disable: true,
      },
      {
        caption: 'Số văn bản',
        dataField: 'DocumentCode',
        width: 148,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        width: 129,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        width: 214,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        width: 142,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        width: 150,
        filterable: true,
        sortable: true,
        visible: true,
        disable: true,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Hạn đề xuất',
        dataField: 'EndDateRequest',
        width: 150,
        filterable: true,
        sortable: true,
        visible: false,
        disable: false,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'CustomStatus',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        width: 146,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolve',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        width: 118,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        width: 142,
        filterable: true,
        sortable: true,
        visible: true,
        disable: false,
        type: 'custom',
        align: 'center',
      },
    ],
    listAllTask: [
      {
        caption: 'Tên công việc',
        dataField: 'TaskName',
        width: 426,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: true,
        isShowExpandIcon: true,
      },
      {
        caption: 'Số văn bản',
        dataField: 'DocumentCode',
        width: 148,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        width: 129,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        width: 214,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        width: 142,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        width: 150,
        filterable: true,
        sortable: true,
        visible: true,
        disable: true,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Hạn đề xuất',
        dataField: 'EndDateRequest',
        width: 150,
        filterable: true,
        sortable: true,
        visible: false,
        disable: false,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'CustomStatus',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        width: 146,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Đánh giá công việc',
        dataField: 'RatingStar',
        width: 160,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolve',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        width: 118,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        width: 142,
        filterable: true,
        sortable: true,
        visible: true,
        disable: false,
        type: 'custom',
        align: 'center',
      },
    ],
    listAssignedByMe: [
      {
        caption: 'Tên công việc',
        dataField: 'TaskName',
        width: 426,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: true,
        isShowExpandIcon: true,
      },
      {
        caption: 'Số văn bản',
        dataField: 'DocumentCode',
        width: 148,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },

      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        width: 129,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        width: 214,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        width: 142,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        width: 150,
        filterable: true,
        sortable: true,
        visible: true,
        disable: true,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Hạn đề xuất',
        dataField: 'EndDateRequest',
        width: 150,
        filterable: true,
        sortable: true,
        visible: false,
        disable: false,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'CustomStatus',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        width: 146,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Đánh giá công việc',
        dataField: 'RatingStar',
        width: 160,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolve',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        width: 118,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },

      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        width: 142,
        filterable: true,
        sortable: true,
        visible: true,
        disable: false,
        type: 'custom',
        align: 'center',
      },
    ],
    listDraft: [
      {
        caption: 'Tên công việc',
        dataField: 'TaskName',
        width: 526,
        isTree: true,
        type: 'custom',
        visible: true,
        isShowExpandIcon: true,
        disable: true,
      },
      {
        caption: 'Số văn bản',
        dataField: 'DocumentCode',
        width: 148,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        width: 129,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        width: 214,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        width: 142,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        width: 150,
        filterable: true,
        sortable: true,
        visible: true,
        disable: true,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        width: 230,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        width: 146,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        width: 230,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolve',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        width: 118,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
    ],
    listDone: [
      {
        caption: 'Tên công việc',
        dataField: 'TaskName',
        width: 426,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: true,
        isShowExpandIcon: true,
      },
      {
        caption: 'Số văn bản',
        dataField: 'DocumentCode',
        width: 148,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        width: 129,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        width: 214,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        width: 142,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        width: 150,
        filterable: true,
        sortable: true,
        visible: true,
        disable: true,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Hạn đề xuất',
        dataField: 'EndDateRequest',
        width: 150,
        filterable: true,
        sortable: true,
        visible: false,
        disable: false,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'CustomStatus',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        width: 146,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Đánh giá công việc',
        dataField: 'RatingStar',
        width: 160,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolve',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        width: 118,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        width: 142,
        filterable: true,
        sortable: true,
        visible: true,
        disable: false,
        type: 'custom',
        align: 'center',
      },
    ],
    listNeedToDo: [
      {
        caption: 'Tên công việc',
        dataField: 'TaskName',
        width: 426,
        isTree: true,
        type: 'custom',
        isShowExpandIcon: true,
        visible: true,
        disable: true,
      },
      {
        caption: 'Số văn bản',
        dataField: 'DocumentCode',
        width: 148,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        width: 129,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        width: 214,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        width: 142,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        width: 150,
        filterable: true,
        sortable: true,
        visible: true,
        disable: true,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Hạn đề xuất',
        dataField: 'EndDateRequest',
        width: 150,
        filterable: true,
        sortable: true,
        visible: false,
        disable: false,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'CustomStatus',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        width: 146,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolve',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        width: 118,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        width: 142,
        filterable: true,
        sortable: true,
        visible: true,
        disable: false,
        type: 'custom',
        align: 'center',
      },
    ],
    listInvolve: [
      {
        caption: 'Tên công việc',
        dataField: 'TaskName',
        width: 426,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: true,
        isShowExpandIcon: true,
      },
      {
        caption: 'Số văn bản',
        dataField: 'DocumentCode',
        width: 148,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        width: 129,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        width: 214,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        width: 142,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        width: 150,
        filterable: true,
        sortable: true,
        visible: true,
        disable: true,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'CustomStatus',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        width: 146,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Đánh giá công việc',
        dataField: 'RatingStar',
        width: 160,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolve',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        width: 118,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        width: 142,
        filterable: true,
        sortable: true,
        visible: true,
        disable: false,
        type: 'custom',
        align: 'center',
      },
    ],
    listApproveUpdateDeadline: [
      {
        caption: 'Tên công việc',
        dataField: 'TaskName',
        width: 426,
        isTree: true,
        type: 'custom',
        isShowExpandIcon: true,
        visible: true,
        disable: true,
      },
      {
        caption: 'Đơn vị chủ trì',
        dataField: 'Executor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        width: 150,
        filterable: true,
        sortable: true,
        visible: true,
        disable: true,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Hạn đề xuất',
        dataField: 'EndDateRequest',
        width: 150,
        filterable: true,
        sortable: true,
        visible: true,
        disable: true,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'CustomStatus',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Lý do đề xuất',
        dataField: 'ReasonEndDateRequest',
        width: 270,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
    ],
    listReportOperateByMe: [
      {
        caption: 'Tên công việc',
        dataField: 'TaskName',
        width: 426,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: true,
        isShowExpandIcon: true,
      },
      {
        caption: 'Số văn bản',
        dataField: 'DocumentCode',
        width: 148,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        width: 129,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        width: 214,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        width: 142,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        width: 150,
        filterable: true,
        sortable: true,
        visible: true,
        disable: true,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'CustomStatus',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        width: 146,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Đánh giá công việc',
        dataField: 'RatingStar',
        width: 160,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolve',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        width: 118,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        width: 142,
        filterable: true,
        sortable: true,
        visible: true,
        disable: false,
        type: 'custom',
        align: 'center',
      },
    ],
    listReportMyOrg: [
      {
        caption: 'Tên công việc',
        dataField: 'TaskName',
        width: 426,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: true,
        isShowExpandIcon: true,
      },
      {
        caption: 'Số văn bản',
        dataField: 'DocumentCode',
        width: 148,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        width: 129,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        width: 214,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        width: 142,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        width: 150,
        filterable: true,
        sortable: true,
        visible: true,
        disable: true,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'CustomStatus',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        width: 146,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Đánh giá công việc',
        dataField: 'RatingStar',
        width: 160,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolve',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        width: 118,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        width: 142,
        filterable: true,
        sortable: true,
        visible: true,
        disable: false,
        type: 'custom',
        align: 'center',
      },
    ],
    listReportPersonality: [
      {
        caption: 'Tên công việc',
        dataField: 'TaskName',
        width: 426,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: true,
        isShowExpandIcon: true,
      },
      {
        caption: 'Số văn bản',
        dataField: 'DocumentCode',
        width: 148,
        isTree: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        width: 129,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        width: 214,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        width: 142,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        width: 150,
        filterable: true,
        sortable: true,
        visible: true,
        disable: true,
        type: 'custom',
        align: 'center',
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'CustomStatus',
        width: 225,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        width: 146,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: true,
        align: 'center',
      },
      {
        caption: 'Đánh giá công việc',
        dataField: 'RatingStar',
        width: 160,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: true,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolve',
        width: 220,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        width: 118,
        filterable: true,
        sortable: true,
        type: 'custom',
        visible: false,
        disable: false,
        align: 'center',
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        width: 142,
        filterable: true,
        sortable: true,
        visible: true,
        disable: false,
        type: 'custom',
        align: 'center',
      },
    ],
  };
  filterAdvanceDefault = {
    listInvolve: [
      {
        caption: 'Thời gian',
        dataField: 'DateRange',
        tooltip:
          'Những công việc có Ngày giao việc hoặc Hạn hoàn thành trong khoảng thời gian này',
        visible: true,
        fix: false,
        sortOrder: 1,
        isCustomTime: true,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        visible: true,
        fix: false,
        sortOrder: 2,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        visible: true,
        fix: false,
        sortOrder: 3,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        visible: true,
        fix: false,
        sortOrder: 4,
        typeControl: ColumnType.ComboboxDocumentSigner,
        value: [
          {
            DocumentSigner: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        visible: true,
        fix: false,
        sortOrder: 5,
        typeControl: ColumnType.ComboboxPriority,
        value: [
          {
            SettingValue: 'Tất cả',
            PriorityName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },

      {
        caption: 'Tình trạng công việc',
        dataField: 'Status',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả tình trạng',
            SettingName: 'Tất cả tình trạng',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        visible: false,
        fix: false,
        sortOrder: 7,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả loại việc',
            TaskTypeName: 'Tất cả loại việc',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        visible: false,
        fix: false,
        sortOrder: 8,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        visible: false,
        fix: false,
        sortOrder: 9,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Đánh giá công việc',
        dataField: 'RatingStar',
        visible: false,
        fix: false,
        sortOrder: 10,
        typeControl: ColumnType.ComboboxRatingStar,
        value: [
          {
            RatingValue: MSEnum.RatingStar.All,
            RatingIcon: 'Tất cả',
            RatingName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        visible: false,
        fix: false,
        sortOrder: 11,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        visible: false,
        fix: false,
        sortOrder: 12,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        visible: false,
        fix: false,
        sortOrder: 13,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolved',
        visible: false,
        fix: false,
        sortOrder: 14,
        typeControl: ColumnType.AddUser,
        value: [],
      },

      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        visible: false,
        fix: false,
        sortOrder: 15,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
    ],
    listAllTask: [
      {
        caption: 'Thời gian',
        dataField: 'DateRange',
        tooltip:
          'Những công việc có Ngày giao việc hoặc Hạn hoàn thành trong khoảng thời gian này',
        visible: true,
        fix: false,
        sortOrder: 1,
        isCustomTime: true,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        visible: true,
        fix: false,
        sortOrder: 2,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        visible: true,
        fix: false,
        sortOrder: 3,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        visible: true,
        fix: false,
        sortOrder: 4,
        typeControl: ColumnType.ComboboxDocumentSigner,
        value: [
          {
            DocumentSigner: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        visible: true,
        fix: false,
        sortOrder: 5,
        typeControl: ColumnType.ComboboxPriority,
        value: [
          {
            SettingValue: 'Tất cả',
            PriorityName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'Status',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả tình trạng',
            SettingName: 'Tất cả tình trạng',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        visible: false,
        fix: false,
        sortOrder: 7,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả loại việc',
            TaskTypeName: 'Tất cả loại việc',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        visible: false,
        fix: false,
        sortOrder: 8,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        visible: false,
        fix: false,
        sortOrder: 9,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Đánh giá công việc',
        dataField: 'RatingStar',
        visible: false,
        fix: false,
        sortOrder: 10,
        typeControl: ColumnType.ComboboxRatingStar,
        value: [
          {
            RatingValue: MSEnum.RatingStar.All,
            RatingIcon: 'Tất cả',
            RatingName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        visible: false,
        fix: false,
        sortOrder: 11,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        visible: false,
        fix: false,
        sortOrder: 12,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        visible: false,
        fix: false,
        sortOrder: 13,
        typeControl: ColumnType.AddUser,
        value: [],
      },

      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolved',
        visible: false,
        fix: false,
        sortOrder: 14,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        visible: false,
        fix: false,
        sortOrder: 15,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
    ],
    listNeedToDo: [
      {
        caption: 'Thời gian',
        dataField: 'DateRange',
        tooltip:
          'Những công việc có Ngày giao việc hoặc Hạn hoàn thành trong khoảng thời gian này',
        visible: true,
        fix: false,
        sortOrder: 1,
        isCustomTime: true,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        visible: true,
        fix: false,
        sortOrder: 2,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        visible: true,
        fix: false,
        sortOrder: 3,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        visible: true,
        fix: false,
        sortOrder: 4,
        typeControl: ColumnType.ComboboxDocumentSigner,
        value: [
          {
            DocumentSigner: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        visible: true,
        fix: false,
        sortOrder: 5,
        typeControl: ColumnType.ComboboxPriority,
        value: [
          {
            SettingValue: 'Tất cả',
            PriorityName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'Status',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả tình trạng',
            SettingName: 'Tất cả tình trạng',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        visible: false,
        fix: false,
        sortOrder: 7,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả loại việc',
            TaskTypeName: 'Tất cả loại việc',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        visible: false,
        fix: false,
        sortOrder: 8,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        visible: false,
        fix: false,
        sortOrder: 9,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        visible: false,
        fix: false,
        sortOrder: 10,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        visible: false,
        fix: false,
        sortOrder: 11,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        visible: false,
        fix: false,
        sortOrder: 12,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolved',
        visible: false,
        fix: false,
        sortOrder: 13,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        visible: false,
        fix: false,
        sortOrder: 14,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
    ],
    listNeedToApprove: [
      {
        caption: 'Thời gian',
        dataField: 'DateRange',
        tooltip:
          'Những công việc có Ngày giao việc hoặc Hạn hoàn thành trong khoảng thời gian này',
        visible: true,
        fix: false,
        sortOrder: 1,
        isCustomTime: true,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        visible: true,
        fix: false,
        sortOrder: 2,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        visible: true,
        fix: false,
        sortOrder: 3,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        visible: true,
        fix: false,
        sortOrder: 4,
        typeControl: ColumnType.ComboboxDocumentSigner,
        value: [
          {
            DocumentSigner: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        visible: true,
        fix: false,
        sortOrder: 5,
        typeControl: ColumnType.ComboboxPriority,
        value: [
          {
            SettingValue: 'Tất cả',
            PriorityName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'Status',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả tình trạng',
            SettingName: 'Tất cả tình trạng',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        visible: false,
        fix: false,
        sortOrder: 7,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả loại việc',
            TaskTypeName: 'Tất cả loại việc',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        visible: false,
        fix: false,
        sortOrder: 8,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        visible: false,
        fix: false,
        sortOrder: 9,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        visible: false,
        fix: false,
        sortOrder: 10,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        visible: false,
        fix: false,
        sortOrder: 11,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        visible: false,
        fix: false,
        sortOrder: 12,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolved',
        visible: false,
        fix: false,
        sortOrder: 13,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        visible: false,
        fix: false,
        sortOrder: 14,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
    ],
    listApproveUpdateDeadline: [
      {
        caption: 'Thời gian',
        dataField: 'DateRange',
        tooltip:
          'Những công việc có Ngày giao việc hoặc Hạn hoàn thành trong khoảng thời gian này',
        visible: true,
        fix: false,
        sortOrder: 1,
        isCustomTime: true,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        visible: true,
        fix: false,
        sortOrder: 2,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        visible: true,
        fix: false,
        sortOrder: 3,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        visible: true,
        fix: false,
        sortOrder: 4,
        typeControl: ColumnType.ComboboxDocumentSigner,
        value: [
          {
            DocumentSigner: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        visible: true,
        fix: false,
        sortOrder: 5,
        typeControl: ColumnType.ComboboxPriority,
        value: [
          {
            SettingValue: 'Tất cả',
            PriorityName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'Status',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả tình trạng',
            SettingName: 'Tất cả tình trạng',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        visible: false,
        fix: false,
        sortOrder: 7,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả loại việc',
            TaskTypeName: 'Tất cả loại việc',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        visible: false,
        fix: false,
        sortOrder: 8,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        visible: false,
        fix: false,
        sortOrder: 9,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        visible: false,
        fix: false,
        sortOrder: 10,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        visible: false,
        fix: false,
        sortOrder: 11,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        visible: false,
        fix: false,
        sortOrder: 12,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolved',
        visible: false,
        fix: false,
        sortOrder: 13,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        visible: false,
        fix: false,
        sortOrder: 14,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
    ],
    listAssignedByMe: [
      {
        caption: 'Thời gian',
        dataField: 'DateRange',
        tooltip:
          'Những công việc có Ngày giao việc hoặc Hạn hoàn thành trong khoảng thời gian này',
        visible: true,
        fix: false,
        sortOrder: 1,
        isCustomTime: true,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        visible: true,
        fix: false,
        sortOrder: 2,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        visible: true,
        fix: false,
        sortOrder: 3,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        visible: true,
        fix: false,
        sortOrder: 4,
        typeControl: ColumnType.ComboboxDocumentSigner,
        value: [
          {
            DocumentSigner: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        visible: true,
        fix: false,
        sortOrder: 5,
        typeControl: ColumnType.ComboboxPriority,
        value: [
          {
            SettingValue: 'Tất cả',
            PriorityName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'Status',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả tình trạng',
            SettingName: 'Tất cả tình trạng',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        visible: false,
        fix: false,
        sortOrder: 7,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả loại việc',
            TaskTypeName: 'Tất cả loại việc',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        visible: false,
        fix: false,
        sortOrder: 8,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },

      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        visible: false,
        fix: false,
        sortOrder: 9,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        visible: false,
        fix: false,
        sortOrder: 10,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Đánh giá công việc',
        dataField: 'RatingStar',
        visible: false,
        fix: false,
        sortOrder: 11,
        typeControl: ColumnType.ComboboxRatingStar,
        value: [
          {
            RatingValue: MSEnum.RatingStar.All,
            RatingIcon: 'Tất cả',
            RatingName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        visible: false,
        fix: false,
        sortOrder: 12,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        visible: false,
        fix: false,
        sortOrder: 13,
        typeControl: ColumnType.AddUser,
        value: [],
      },

      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolved',
        visible: false,
        fix: false,
        sortOrder: 14,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        visible: false,
        fix: false,
        sortOrder: 15,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
    ],

    listDraft: [
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        visible: true,
        fix: false,
        sortOrder: 1,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        visible: true,
        fix: false,
        sortOrder: 2,
        typeControl: ColumnType.ComboboxDocumentSigner,
        value: [
          {
            DocumentSigner: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        visible: true,
        fix: false,
        sortOrder: 3,
        typeControl: ColumnType.ComboboxPriority,
        value: [
          {
            SettingValue: 'Tất cả',
            PriorityName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        visible: false,
        fix: false,
        sortOrder: 4,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả loại việc',
            TaskTypeName: 'Tất cả loại việc',
            isChooseAll: true,
          },
        ],
      },

      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        visible: false,
        fix: false,
        sortOrder: 5,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        visible: false,
        fix: false,
        sortOrder: 7,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        visible: false,
        fix: false,
        sortOrder: 8,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolved',
        visible: false,
        fix: false,
        sortOrder: 9,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        visible: false,
        fix: false,
        sortOrder: 10,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
    ],
    listDone: [
      {
        caption: 'Thời gian',
        dataField: 'DateRange',
        tooltip:
          'Những công việc có Ngày giao việc hoặc Hạn hoàn thành trong khoảng thời gian này',
        visible: true,
        fix: false,
        sortOrder: 1,
        isCustomTime: true,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        visible: true,
        fix: false,
        sortOrder: 2,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        visible: true,
        fix: false,
        sortOrder: 3,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        visible: true,
        fix: false,
        sortOrder: 4,
        typeControl: ColumnType.ComboboxDocumentSigner,
        value: [
          {
            DocumentSigner: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        visible: true,
        fix: false,
        sortOrder: 5,
        typeControl: ColumnType.ComboboxPriority,
        value: [
          {
            SettingValue: 'Tất cả',
            PriorityName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'Status',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả tình trạng',
            SettingName: 'Tất cả tình trạng',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        visible: false,
        fix: false,
        sortOrder: 7,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả loại việc',
            TaskTypeName: 'Tất cả loại việc',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        visible: false,
        fix: false,
        sortOrder: 8,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        visible: false,
        fix: false,
        sortOrder: 9,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Đánh giá công việc',
        dataField: 'RatingStar',
        visible: false,
        fix: false,
        sortOrder: 10,
        typeControl: ColumnType.ComboboxRatingStar,
        value: [
          {
            RatingValue: MSEnum.RatingStar.All,
            RatingIcon: 'Tất cả',
            RatingName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        visible: false,
        fix: false,
        sortOrder: 11,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        visible: false,
        fix: false,
        sortOrder: 12,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        visible: false,
        fix: false,
        sortOrder: 13,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolved',
        visible: false,
        fix: false,
        sortOrder: 14,
        typeControl: ColumnType.AddUser,
        value: [],
      },

      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        visible: false,
        fix: false,
        sortOrder: 15,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
    ],
    listRelatedToMe: [
      {
        caption: 'Thời gian',
        dataField: 'DateRange',
        tooltip:
          'Những công việc có Ngày giao việc hoặc Hạn hoàn thành trong khoảng thời gian này',
        visible: true,
        fix: false,
        sortOrder: 1,
        isCustomTime: true,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Hạn hoàn thành',
        dataField: 'EndDate',
        visible: true,
        fix: false,
        sortOrder: 2,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Người/Đơn vị chủ trì',
        dataField: 'Executor',
        visible: true,
        fix: false,
        sortOrder: 3,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người ký ban hành',
        dataField: 'DocumentSigner',
        visible: true,
        fix: false,
        sortOrder: 4,
        typeControl: ColumnType.ComboboxDocumentSigner,
        value: [
          {
            DocumentSigner: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Mức độ ưu tiên',
        dataField: 'Priority',
        visible: true,
        fix: false,
        sortOrder: 5,
        typeControl: ColumnType.ComboboxPriority,
        value: [
          {
            SettingValue: 'Tất cả',
            PriorityName: 'Tất cả',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Tình trạng công việc',
        dataField: 'Status',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả tình trạng',
            SettingName: 'Tất cả tình trạng',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Trạng thái phê duyệt của Bộ',
        dataField: 'StatusApprovalMission',
        visible: false,
        fix: false,
        sortOrder: 6,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Loại việc',
        dataField: 'TaskType',
        visible: false,
        fix: false,
        sortOrder: 7,
        typeControl: ColumnType.ComboboxMultiple,
        value: [
          {
            SettingValue: 'Tất cả loại việc',
            TaskTypeName: 'Tất cả loại việc',
            isChooseAll: true,
          },
        ],
      },
      {
        caption: 'Ngày bắt đầu',
        dataField: 'StartDate',
        visible: false,
        fix: false,
        sortOrder: 8,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
      {
        caption: 'Ngày giao việc',
        dataField: 'SendTaskDate',
        visible: false,
        fix: false,
        sortOrder: 9,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },

      {
        caption: 'Người/Đơn vị phối hợp',
        dataField: 'Combination',
        visible: false,
        fix: false,
        sortOrder: 10,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người liên quan',
        dataField: 'PeopleInvolved',
        visible: false,
        fix: false,
        sortOrder: 11,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người giao việc',
        dataField: 'Assigner',
        visible: false,
        fix: false,
        sortOrder: 12,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Người phụ trách',
        dataField: 'Supervisor',
        visible: false,
        fix: false,
        sortOrder: 13,
        typeControl: ColumnType.AddUser,
        value: [],
      },
      {
        caption: 'Ngày ban hành',
        dataField: 'DocumentDate',
        visible: false,
        fix: false,
        sortOrder: 14,
        typeControl: ColumnType.DateCombobox,
        value: {
          comboboxValue: [
            {
              SettingValue: MSEnum.DateTimeValueType.All,
              SettingName: 'Tất cả',
            },
          ],
        },
      },
    ],
  };
  sortDefault = {
    listAllTask: {
      sortValue: [
        {
          SortID: 1,
          SortName: 'Tình trạng công việc',
        },
      ],
      sortType: 2,
    },
    listNeedToDo: {
      sortValue: [
        {
          SortID: 1,
          SortName: 'Tình trạng công việc',
        },
      ],
      sortType: 2,
    },
    listNeedToApprove: {
      sortValue: [
        {
          SortID: 1,
          SortName: 'Tình trạng công việc',
        },
      ],
      sortType: 2,
    },
    listAssignedByMe: {
      sortValue: [
        {
          SortID: 1,
          SortName: 'Tình trạng công việc',
        },
      ],
      sortType: 2,
    },
    listInvolve: {
      sortValue: [
        {
          SortID: 1,
          SortName: 'Tình trạng công việc',
        },
      ],
      sortType: 2,
    },
    listDone: {
      sortValue: [
        {
          SortID: 1,
          SortName: 'Tình trạng công việc',
        },
      ],
      sortType: 2,
    },
    listDraft: { isVisible: true },
    listApproveUpdateDeadline: {
      sortValue: [
        {
          SortID: 1,
          SortName: 'Tình trạng công việc',
        },
      ],
      sortType: 2,
    },
    listReportOperateByMe: {
      sortValue: [
        {
          SortID: 1,
          SortName: 'Tình trạng công việc',
        },
      ],
      sortType: 2,
    },
    listReportMyOrg: {
      sortValue: [
        {
          SortID: 1,
          SortName: 'Tình trạng công việc',
        },
      ],
      sortType: 2,
    },
    listReportPersonality: {
      sortValue: [
        {
          SortID: 1,
          SortName: 'Tình trạng công việc',
        },
      ],
      sortType: 2,
    },
  };
  filterNotificationDefault = [
    {
      SettingFilterID: 1,
      SettingFilterName: 'Người giao việc',
      IsActive: true,
      SortOrder: 1,
      Type: 1,
    },
    {
      SettingFilterID: 2,
      SettingFilterName: 'Người phụ trách',
      IsActive: true,
      SortOrder: 2,
      Type: 1,
    },
    {
      SettingFilterID: 3,
      SettingFilterName: 'Người chủ trì',
      IsActive: true,
      SortOrder: 3,
      Type: 1,
    },
    {
      SettingFilterID: 4,
      SettingFilterName: 'Người phối hợp',
      IsActive: true,
      SortOrder: 4,
      Type: 1,
    },
    {
      SettingFilterID: 5,
      SettingFilterName: 'Người liên quan',
      IsActive: true,
      SortOrder: 5,
      Type: 1,
    },
  ];
}
export default new ListConfigDefault();
